import { useIntl } from 'react-intl';

import { PresetKey } from './types';

export const usePreset = (preset: PresetKey) => {
  const intl = useIntl();

  switch (preset) {
    case 'clear-all':
      return {
        icon: 'x' as const,
        size: 's' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.clearAllTooltip',
          defaultMessage: 'Clear all',
          description: 'Tooltip for clear all icon button',
        }),
      };
    case 'hide':
      return {
        icon: 'chevron-up' as const,
        size: 's' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.hideTooltip',
          defaultMessage: 'Hide',
          description: 'Tooltip for hide icon button',
        }),
      };
    case 'maximize':
      return {
        icon: 'maximize' as const,
        size: 'm' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.maximizeTooltip',
          defaultMessage: 'Maximize',
          description: 'Tooltip for maximize icon button',
        }),
      };
    case 'minimize':
      return {
        icon: 'minimize' as const,
        size: 'm' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.minimizeTooltip',
          defaultMessage: 'Minimize',
          description: 'Tooltip for minimize icon button',
        }),
      };
    case 'show':
      return {
        icon: 'chevron-down' as const,
        size: 's' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.showTooltip',
          defaultMessage: 'Show',
          description: 'Tooltip for show icon button',
        }),
      };
    case 'close':
      return {
        icon: 'x' as const,
        size: 'm' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.closeTooltip',
          defaultMessage: 'Close',
          description: 'Tooltip for close icon button',
        }),
      };
    case 'pin':
      return {
        icon: 'push-pin' as const,
        size: 's' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.pinTooltip',
          defaultMessage: 'Pin',
          description: 'Tooltip for pin icon button',
        }),
      };
    case 'unpin':
      return {
        icon: 'push-pin' as const,
        size: 's' as const,
        status: 'active' as const,
        tooltip: intl.formatMessage({
          id: 'IconButton.unpinTooltip',
          defaultMessage: 'Unpin',
          description: 'Tooltip for unpin icon button',
        }),
      };
    default:
      return {};
  }
};
